import { css } from '@emotion/react';
import { Stack } from '@mui/material';
import { useAtomValue } from 'jotai';
import { Breakpoint, ContainerName } from '../../../constants/styles';
import { selectedFundStateFP } from '../state/FPState';
import { ContributionsDistributions } from './ContributionsDistributions';
import { FPDigestPanel } from './FPDigestPanel';
import { FundMetricsPanel } from './FundMetricsPanel';
import { InvestorCashFlowsSection } from './InvestorCashFlows/InvestorCashFlowsSection';

const DigestAndMetricsSection = css`
  display: grid;
  gap: 1rem;
  @container ${ContainerName.fundProfilesContainer} (width >= ${Breakpoint.profilePanels}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export function FPSummary() {
  const fund = useAtomValue(selectedFundStateFP);

  if (!fund) {
    return null;
  }
  return (
    <Stack display={'grid'} gap={'1rem'}>
      <section css={DigestAndMetricsSection}>
        <FPDigestPanel fund={fund} />
        <FundMetricsPanel />
      </section>
      <InvestorCashFlowsSection fundId={fund.id} />
      <ContributionsDistributions />
    </Stack>
  );
}
